<template>
  <div class="container">
    <div class="top">
      <img class="top-left" :src="schoolIcon(tripInfo.cover_image)" alt="" width="60px" height="60px">
      <div class="top-center">
        <span class="top-center-universtiy ellipsis line2">{{ tripInfo.school_name }}</span>
        <span v-if="tripInfo.preach_begintime!==undefined" class="top-center-time">时间：{{ tripInfo.preach_begintime | formatDateTime }}</span>
        <span v-else class="top-center-time">时间：敬请期待</span>
      </div>
      <div class="top-right">
        <van-tag v-if="tripInfo.progress_status==='OnGoing'" class="top-right-content-underway">进行中</van-tag>
        <van-tag v-if="tripInfo.progress_status==='NotStart'" class="top-right-content-not-start">未开始</van-tag>
        <van-tag v-if="tripInfo.progress_status==='End'" class="top-right-content-end">已结束</van-tag>
      </div>
    </div>
    <div class="location-wrapper">
      <div class="location">
        <icon-svg class="location-icon" name="location"></icon-svg>
        <div class="location-detail">
          <span>{{ tripInfo.address }}</span>
        </div>
      </div>
    </div>
    <div class="steps">
      <div class="steps-title">笔试面试安排</div>
      <van-steps direction="vertical" active="-1">
        <van-step>
          <div class="step-title">
            <img class="step-image" src="../../../assets/images/schedule/trip-step1.png" alt="" width="57px" height="18px">
            <div class="step-title-text">简历截止</div>
          </div>
          <p v-if="tripInfo.resume_deadline!==undefined" class="step-time">{{ tripInfo.resume_deadline | formatDateTime }}</p>
          <p v-else class="step-time">敬请期待，精彩宣讲活动即将上线</p>
        </van-step>
        <van-step>
          <div class="step-title">
            <img class="step-image" src="../../../assets/images/schedule/trip-step2.png" alt="" width="57px" height="18px">
            <div class="step-title-text">线上笔试</div>
          </div>
          <p v-if="tripInfo.written_begintime!==undefined" class="step-time">{{ tripInfo.written_begintime | formatDateTime }} 至 {{ tripInfo.written_endtime | formatDateTime }}</p>
          <p v-else class="step-time">敬请期待，精彩宣讲活动即将上线</p>
        </van-step>
        <van-step>
          <div class="step-title">
            <img class="step-image" src="../../../assets/images/schedule/trip-step3.png" alt="" width="57px" height="18px">
            <div class="step-title-text">面试</div>
          </div>
          <p v-if="tripInfo.interview_begintime!==undefined" class="step-time">{{ tripInfo.interview_begintime | formatDateTime }} 至 {{ tripInfo.interview_endtime | formatDateTime }}</p>
          <p v-else class="step-time">敬请期待，精彩宣讲活动即将上线</p>
        </van-step>
      </van-steps>
    </div>
    <van-button v-if="tripInfo.progress_status!=='End' && tripInfo.enroll_flag===false" round type="info" class="apply" @click="toApply">我要报名</van-button>
    <van-button v-if="tripInfo.progress_status!=='End' && tripInfo.enroll_flag===true" round type="info" class="apply-end">已报名</van-button>
    <van-button v-if="tripInfo.progress_status==='End'" round type="info" class="apply-end">已结束</van-button>
  </div>
</template>

<script>
import cookies from '@/libs/util.cookies'
import util from "../../../libs/util";

export default {
  name: 'ScheDuleDetail',
  data() {
    return {
      tripInfo: '',
      tripId: '',
      coverImage: ''
    }
  },
  computed: {
  },
  created() {
    this.tripId = this.$route.params.id
    const params = {
      user_id: cookies.get('uid')
    }
    this.$api.RECRUIT_TRIP_Info(
      this.tripId,
      params
    ).then(res => {
      this.tripInfo = res
      // 配置微信分享信息
      const shareParam = {
        title: "加入我们，实现价值",
        desc: "卫宁健康2027校园招聘\r\n" + this.tripInfo.school_name,
        link:  process.env.VUE_APP_BASEURL +'/#/schedule/detail/' + this.tripId,
        imgUrl: process.env.VUE_APP_SHARE_IMG_URL
      }
      util.initWXSdk(shareParam)
    })
  },
  mounted () { },
  methods: {
    schoolIcon(id){
      return `${process.env.VUE_APP_IMAGE_URL}/file?id=${id}`
    },
    toApply() {
      this.$router.push({
        name: 'ScheDuleApply',
        params: {
          id: this.tripId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    height: calc(100vh - 50px);
  }
  .top {
    display: flex;
    text-align: left;
    .top-left {
      margin: 20px 0px 0px 20px;
    }

    .top-center {
      margin: 25px 3px 0px 12px;
      flex-grow: 1;
      .top-center-universtiy {
        font-size: 18px;
        font-weight: bold;
        line-height: 22px;
      }

      .top-center-time {
        display: block;
        font-size: 14px;
        margin: 5px 0px 0px 0px;
      }
    }

    .top-right {
      margin-top: 23px;
      margin-right: 20px;
      justify-self: flex-end;
      .top-right-content-underway {
        width: 52px;
        height: 22px;
        background: linear-gradient(90deg, #FF9900 0%, #FF8D19 24%, #FE6868 100%);
        border-radius: 4px;
        font-size: 12px;
        text-align: center;
        color: #FFFFFF;
      }
      .top-right-content-not-start {
        width: 52px;
        height: 22px;
        background: linear-gradient(90deg, #3871FF 0%, #2E5DD2 100%);
        border-radius: 4px;
        font-size: 12px;
        text-align: center;
        color: #FFFFFF;
      }
      .top-right-content-end {
        width: 52px;
        height: 22px;
        background: linear-gradient(90deg, #F5F5F5 1%, #F0F0F0 99%);
        border-radius: 4px;
        font-size: 12px;
        text-align: center;
        color: #666666;
      }
    }
  }

  .location-wrapper {
    margin: 19px 20px 25px 20px;
    padding: 12px 16px 12px 14px;
    background-color: #F8FAFB;
    border-radius: 10px;
    .location {
      display: flex;
      .location-icon {
          width: 13px;
          height: 16px;
          margin-top: 1.5px;
        }
      .location-detail {
        font-size: 14px;
        text-align: left;
        margin-left: 10px;
      }
    }
  }

  .steps {
    .steps-title {
      text-align: left;
      font-size: 18px;
      font-weight: bold;
      margin: 0px 0px 16px 21px;
    }

    .steps-line {
      position: absolute;
      left: 26px;
      top: 263px;
    }

    .step-title {
      text-align: left;
      display: flex;
      position: relative;
      right: 18px;
      .step-title-text {
        height: 18px;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        margin-left: 8px;
        position: relative;
        // top: -1px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }

    .step-time {
      text-align: left;
      font-size: 12px;
      color: #999999;
      margin-top: 8px;
      font-family: PingFangSC-Regular, PingFang SC;
    }
  }

  ::v-deep {
    .van-hairline::after {
      border: 0;
    }

    .van-steps--vertical {
      margin-left: 12px;
    }

    .van-step--vertical {
      padding: 0;
    }

    .van-step {
      color: #999999;
      height: 69px;
      .van-step__title {
        color: #333333;
      }
    }

    .van-step__circle-container {
      display: none;

      .van-step__circle {
        display: none;
      }
    }

    .van-step__line {
      background-color: #2E5DD2;
      height: 51px;
      margin-top: 3px;
      left: -14px;
    }

    .apply {
      width: 335px;
      height: 44px;
      border-radius: 20px;
      background: linear-gradient(90deg, #3871FF 0%, #2E5DD2 100%);
      position: absolute;
      bottom: 20px;
      left: 20px;
      font-size: 16px;
      font-weight: bold;
    }

    .apply-end {
      width: 335px;
      height: 44px;
      border-radius: 20px;
      background: linear-gradient(90deg, #3871FF 0%, #2E5DD2 100%);
      position: absolute;
      bottom: 20px;
      left: 20px;
      color: rgba($color: #FFFFFF, $alpha: 0.3);
      font-size: 16px;
      font-weight: bold;
    }

    p {
      margin: 0
    }
  }
</style>
